import {
  ADD_PARTNER,
  GET_ALL_PARTNERS,
  GET_SINGLE_PARTNER,
  UPDATE_PARTNER,
  DELETE_PARTNER,
  PARTNER_ERROR,
} from '../actionTypes';

const initPartnerState = {
  error: null,
  partners: [],
  message: null,
  loading: true,
};

const partnerReducer = (state = initPartnerState, action) => {
  switch (action.type) {
    case GET_ALL_PARTNERS:
      return {
        ...state,
        error: null,
        loading: false,
        partners: [...action.payload.partners],
      };
    case ADD_PARTNER:
      return {
        ...state,
        error: null,
        message: action.payload.message,
        partners: [action.payload.partner, ...state.partners].sort(
          (a, b) => (a.order || 0) - (b.order || 0),
        ),
      };
    case GET_SINGLE_PARTNER:
      return {
        ...state,
        error: null,
        message: action.payload.message,
        partners: state.partners.map(partner =>
          partner._id !== action.payload.partner._id
            ? partner
            : action.payload.partner,
        ),
      };
    case UPDATE_PARTNER:
      return {
        ...state,
        error: null,
        message: action.payload.message,
        partners: state.partners
          .map(partner =>
            partner._id !== action.payload.partner._id
              ? partner
              : action.payload.partner,
          )
          .sort((a, b) => (a.order || 0) - (b.order || 0)),
      };
    case DELETE_PARTNER:
      return {
        ...state,
        error: null,
        message: action.payload.message,
        partners: state.partners.filter(
          partner => partner._id !== action.payload.id,
        ),
      };
    case PARTNER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default partnerReducer;
